import { z } from 'zod';

import { COVERAGE_STATUSES, type CoverageStatus } from '@/shared/model/enums';

/** A masjid pin on the admin map (Phase 5, D-013). */
export interface MasjidMapItem {
  readonly id: string;
  readonly name: string;
  readonly city: string | null;
  readonly latitude: number;
  readonly longitude: number;
}

/** A coverage-request pin on the admin map, joined with its masjid location. */
export interface RequestMapItem {
  readonly id: string;
  readonly status: CoverageStatus;
  readonly masjidId: string;
  readonly masjidName: string;
  readonly latitude: number;
  readonly longitude: number;
  readonly startDate: string;
  readonly endDate: string;
}

const masjidRowSchema = z.object({
  id: z.string(),
  name: z.string(),
  city: z.string().nullable(),
  latitude: z.number(),
  longitude: z.number(),
});

const requestRowSchema = z.object({
  id: z.string(),
  status: z.enum(COVERAGE_STATUSES),
  masjid_id: z.string(),
  start_date: z.string(),
  end_date: z.string(),
  masjids: z.object({
    name: z.string(),
    latitude: z.number(),
    longitude: z.number(),
  }),
});

export function mapMasjidMapItem(row: unknown): MasjidMapItem {
  return masjidRowSchema.parse(row);
}

export function mapRequestMapItem(row: unknown): RequestMapItem {
  const r = requestRowSchema.parse(row);
  return {
    id: r.id,
    status: r.status,
    masjidId: r.masjid_id,
    masjidName: r.masjids.name,
    latitude: r.masjids.latitude,
    longitude: r.masjids.longitude,
    startDate: r.start_date,
    endDate: r.end_date,
  };
}
